<template>
  <van-dialog
    v-model="show"
    :class="`dialogWrap ${isNight ? 'dialogWrap_dark' : ''}`"
    :show-confirm-button="false"
    @opened="openedDialog"
    :transition="'dialog'"
  >
    <div class="contentWrap">
      <div class="confettiWrap" v-if="true">
        <Confetti ref="confetti" />
      </div>
      <div class="dialogTitle"> {{dialogTitle}} </div>
      <div class="dialogTip">{{dialogTip}}</div>
      <div class="lottieWrap" v-if="defaultOptions.animationData">
        <Lottie :options="defaultOptions" :height="'2.04rem'" :width="'4.26rem'" v-on:animCreated="handleAnimation" class="lottie" />
        <img src="./images/moneyOof.webp" class="moneyCoin"/>
        <img src="./images/awardCoin.webp" class="coins"/>
        <div class="moneySum" :style="style">{{ symbol+ranking}}</div>
      </div>
      <div class="awardWrap">
        <div class="awardTip">{{awardTip}}</div>
      </div>
    </div>
    <div class="buttonWrap" >
      <div class="buttonContainer">
        <button class="leftBtn btn" @click="laterShare">{{btn}}</button>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import Lottie from '@src/components/lottie'
import Confetti from './confetti'
import moneylight from './images/moneylight.json'

const getComputedAnim = ranking => {
  console.log('ranking', ranking)
  return moneylight
}
export default {
  components: {
    Confetti,
    Lottie
  },
  props: ['awardData', 'show', 'ranking', 'symbol', 'isNight','dialogTitle','dialogTip','awardTip','btn'],
  data() {
    return {
      defaultOptions: {
        animationData: null,
        autoplay: false,
        loop: false
      },
      style:{},
      currencySignLength:0,
      currencyAmountLength:0,
      sumLength:0,
    }
  },
  mounted() {
    this.defaultOptions.animationData = getComputedAnim(this.ranking)
    this.currencySignLength = this.symbol.length
    this.currencyAmountLength = this.ranking.toString().length 
    this.sumLength = this.currencySignLength + this.currencyAmountLength
    if(this.sumLength > 5) {
      this.style = "fontSize:0.6rem"
    }

  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim
      window.anim = anim
      // anim.addEventListener('DOMLoaded', () => {
      //   let rankingArr = this.ranking
      //     .toString()
      //     .split('')
      //     rankingArr.unshift(this.symbol)
      //   const element = document.getElementById('rank')
      //   for (let i = 0; i < rankingArr.length; i++) {
      //     element.getElementsByTagName('text')[i].innerHTML = rankingArr[i]
      //   }
      // })
    },
    toShare() {
      this.$emit('awardShare')
    },
    laterShare() {
      this.$emit('laterShare')
    },
    openedDialog() {
      this.anim.play()
      if (this.awardData) {
        let that = this
        setTimeout(() => {
          this.$refs.confetti.draw()
          setTimeout(() => {
            that.$refs.confetti.draw()
          }, 2000)
        }, 600)
      }
    }
  },
  computed: {
    translateCheck() {
      if (this.$i18n.locale === 'zh-CN') {
        return '：'
      } else {
        return ''
      }
    },
    congratulations() {
      if (this.$i18n.locale === 'en-US') {
        return this.$t('resultDialog.congratulations').toUpperCase()
      } else {
        return this.$t('resultDialog.congratulations')
      }
    }
  }
}
</script>

<style scoped lang="stylus">
@keyframes imgFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fade-enter-active {
  animation: imgFade 15s;
}
.dialogWrap {
  width: 9.6rem
  top: 50% !important
  background-color: #fafafa
  border-radius: 0.54rem
  .contentWrap {
    position: relative;
    // padding-top: 0.14rem;
    .confettiWrap {
      position: relative;
      width: 100%;
    }
    .lottieWrap {
      margin-top 1.08rem
      margin-bottom 1.17rem
      position: relative;
      width: 100%;
      display flex
      height 2.04rem
      align-items center
      justify-content center
      .moneyCoin{
        position absolute
        width: 4.26rem;
        height:2.04rem;
      }
      .moneySum {
        position absolute
        color: #2A9657;
        font-weight: 600;
        font-size: 0.72rem;
      }
      .coins{
        position absolute
        width 4.92rem
        height 1.11rem
        bottom -0.55rem
        left 50%
        transform translateX(-50%)
      }
      .lottie {
        position absolute
        transform  translateX(-50%)
        left 50%
        z-index 22
      }
      .svg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 9.6rem;
        height: 10.902rem;
      }
    }
    .dialogTitle {
      margin: 0.72rem 0.9rem 0;
      font-size: 0.72rem;
      font-family: 'OPPOSans 2.14 NoVF';
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      text-align: center;
      height: 1.02rem;
      line-height: 1.02rem;
      text-transform: uppercase;
    }
    .dialogTip {
      height:0.6rem;
      line-height :0.6rem;
      margin: 0.12rem 0.9rem 0;
      word-break:keep-all
      font-size: 0.42rem;
      color: rgba(0, 0, 0, 0.85);
      font-family: 'OPPOSans 2.14 NoVF';
      // font-weight: 500;
      text-align: center;
    }
    .awardWrap {
      margin:0 0.9rem 0.3rem;
      .awardTip {
        font-size: 0.42rem;
        text-align :center
        height: 0.6rem;
        word-break:keep-all
        line-height 0.6rem
        color: rgba(0, 0, 0, 0.55);
        font-family: 'OPPOSans 2.14 NoVF';
      }
    }
  }
  .buttonWrap {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 0.42rem;
    .verticalLine {
      height: 0.66rem;
      width: 0.03rem;
      background-color: rgba(0, 0, 0, 0.12);
    }
    .buttonContainer {
      flex: 1;
      .btn {
        height: 1.74rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: none;
        font-weight: 500;
        font-family: 'OPPOSans 2.14 NoVF';
        font-size: 0.42rem;
        background-color: rgba(216, 216, 216, 0.0001);
      }
      .leftBtn {
        color: #FD8326;
      }
    }
  }
}
.dialogWrap_dark {
  background-color: #404040;
  .contentWrap {
    .dialogTitle {
      color: rgba(255, 255, 255, 0.85);
    }
    .dialogTip {
      color: rgba(255, 255, 255, 0.85);
    }
    .awardWrap {
      .awardTip {
        color: rgba(255, 255, 255, 0.55);;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/awardDialog/index.vue